<div xmlns="http://www.w3.org/1999/html">

    <mat-expansion-panel class="light-flex-card tv-mat-expansion-indicator-light-bg">
        <mat-expansion-panel-header>
            <mat-panel-title class="sub-title">
                Négociations Nationales
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="header-item-filters">
            <!-- Search -->
            <!--            <mat-form-field-->
            <!--                    class="tv-ns-white-search-medium"-->
            <!--                    floatLabel="never"-->
            <!--            >-->
            <!--                <mat-icon matPrefix class="small-icon">search</mat-icon>-->
            <!--                <input matInput [formControl]="" name="search"/>-->
            <!--            </mat-form-field>-->

            <!-- Add -->
            <button
                    (click)="openNatioNegoModal()"
                    class="tv-round-icon-button-icon-small-light-blue"
            >
                <mat-icon>add</mat-icon>
            </button>
        </div>

        <div class="container">
            <div class="item" *ngFor="let negotiation of natioNegotiationList">
                <div class="item-content">
                    <div class="item-header">
                        <!--                        <span class="discountCode">{{ negotiation.id }}</span>-->
                        <span class="discountCode">{{ negotiation.negotiationType.id }}</span>
                        <span class="discountLabel">{{ negotiation.negotiationType.name }}</span>
                        <span class="date-range">{{ negotiation.startDate }} - {{ negotiation.endDate }}</span>
                        <span class="ca" *ngIf="! negotiation.rate">{{ negotiation.value?.toLocaleString('fr-FR') }}
                            €</span>
                        <span class="ca" *ngIf="! negotiation.value">{{ negotiation.rate }}
                            %</span>
                    </div>

                    <div class="item-options">
                        <ng-container *ngFor="let conditions of negotiation.groupedConditions">
                            <mat-icon *ngIf="conditions[0].isInclude === 1 " class="option-type-icon"
                                      svgIcon="add-circle-fill"></mat-icon>
                            <mat-icon *ngIf="conditions[0].isInclude === 0" class="option-type-icon"
                                      svgIcon="delete-circle-fill"></mat-icon>
                            <div class="option-value">
                                <div *ngFor="let condition of conditions">
                                    <span> {{condition.categoryValue?.labelCategoryValue }}
                                        ({{ condition.categoryValue?.idCategoryValue }}) -  </span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>

                <div class="item-actions">
                    <mat-icon svgIcon="edit" (click)="openNatioNegoModal(negotiation, false)"></mat-icon>
                    <mat-icon svgIcon="content-copy" (click)="openNatioNegoModal(negotiation, true)"></mat-icon>
                    <mat-icon svgIcon="delete-bin" (click)="removeNatioNegotiation(negotiation)"></mat-icon>
                </div>
            </div>
        </div>
    </mat-expansion-panel>

</div>
